import axios from './_nestAxios'
import inveaxios from './_inveAxios'

export const login = async info => {
  const { data } = await axios.post('/auth/login', info)
  return data
}

export const solicitarCambioContrasena = data => axios.post('/auth/solicitar-cambio-contrasena', data)

export const getSesionInfo = () => axios.get('/auth/sesion-info')
export const obtenerCompaniaLogo = () => inveaxios.get('/auth/obtener-compania-logo')
export const getCompaniasHabilitadas = () => axios.get('/auth/companias-habilitadas')

export const getSedesHabilitadas = () => inveaxios.get('/auth/sedes-habilitadas')

export const cambiarCompania = data => axios.put('/auth/cambiar-compania', data)
export const cambiarMesTrabajo = data => axios.put('/auth/cambiar-mes', data)
